import React, { ReactNode, useMemo } from "react";

import cn from "classnames";
import { IntlShape } from "react-intl";

import ImportStatus from "@mapmycustomers/shared/enum/imports/ImportStatus";
import Import from "@mapmycustomers/shared/types/imports/Import";

import { downloadFile as downloadFileAction } from "@app/store/files/actions";

import styles from "./FinalizeStep.module.scss";
import getExtra from "./util/getExtra";
import getImage from "./util/getImage";
import getSubtitle from "./util/getSubtitle";
import getTitle from "./util/getTitle";

export type ImportResultState = {
  extra: ReactNode[];
  img: ReactNode;
  subTitle: ReactNode;
  title: ReactNode;
};

const useResultState = (
  intl: IntlShape,
  downloadFile: typeof downloadFileAction,
  importRecord?: Import
): ImportResultState =>
  useMemo(() => {
    const status = importRecord?.status ?? ImportStatus.QUEUED;
    return {
      extra: getExtra(intl, downloadFile, importRecord),
      img: (
        <img
          alt={`Import status: ${status}`}
          className={cn({ [styles.rotateImage]: status === ImportStatus.QUEUED })}
          src={getImage(importRecord)}
        />
      ),
      subTitle: getSubtitle(intl, importRecord),
      title: getTitle(intl, importRecord),
    };
  }, [intl, downloadFile, importRecord]);

export default useResultState;
